export default "/images/6f58a7d975531f3542bf00ec72a485d0.avif";